<template>
  <div id="storeVoucherForm" class="modal-form">
    <b-row no-gutters class="mb-2">
      <b-col sm="12" md="4">
        <h6 class="main-label">
          Voucher Type<i id="voucher-type-label-help" class="help d-none"></i>
        </h6>
        <b-popover
          target="voucher-type-label-help"
          triggers="hover"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        >
        </b-popover>
      </b-col>
      <b-col>
        <b-form-group id="voucher-type-container">
          <b-form-radio-group
            :id="'radio-group' + '-' + fromWhatModal"
            v-model="form.voucher_type"
          >
            <b-form-radio :disabled="fromWhatModal == 'edit'" value="generic"
              >Generic</b-form-radio
            >
            <b-form-radio :disabled="fromWhatModal == 'edit'" value="unique"
              >Unique</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-2">
      <b-col sm="12" md="4">
        <h6 class="main-label">Store Voucher</h6>
      </b-col>
      <b-col>
        <b-form-group
          id="voucherName"
          label="Campaign Name"
          label-for="name"
          class="secondary-label mb-3"
          :invalid-feedback="errorMessage('name')"
          :state="isValid('name')"
        >
          <b-form-input
            :id="'name' + fromWhatModal"
            type="text"
            v-model="form.name"
            maxlength="40"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          v-if="form.voucher_type != 'unique'"
          id="genericCode"
          label="Generic Code"
          label-for="genericCode"
          class="secondary-label mb-3"
          :invalid-feedback="errorMessage('generic_code')"
          :state="isValid('generic_code')"
        >
          <b-form-input
            :id="'genericCode' + fromWhatModal"
            type="text"
            :disabled="fromWhatModal == 'edit'"
            v-model="form.generic_code"
            maxlength="12"
            @keypress.native="isLetterOrNumber($event)"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-2" v-if="form.voucher_type != 'unique'">
      <b-col sm="12" md="4">
        <h6 class="main-label">Code Quantity</h6>
      </b-col>
      <b-col>
        <b-row no-gutters>
          <b-col>
            <b-form-group
              :id="'code-quantity-group' + '-' + fromWhatModal"
              label-for="codeQuantity"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('code_quantity')"
              :state="isValid('code_quantity')"
            >
              <b-form-input
                v-if="fromWhatModal == 'new'"
                :disabled="form.is_unlimited == true"
                :id="'code-quantity-input' + '-' + fromWhatModal"
                type="number"
                min="1"
                max="9999999999"
                pattern="/^-?\d+\.?\d*$/"
                onKeyPress="if(this.value.length==10) return false;"
                v-model="form.code_quantity"
              ></b-form-input>
              <b-form-input
                v-else-if="fromWhatModal == 'edit'"
                disabled
                :id="'code-quantity-input' + '-' + fromWhatModal"
                type="number"
                min="1"
                max="9999999999"
                pattern="/^-?\d+\.?\d*$/"
                onKeyPress="if(this.value.length==10) return false;"
                v-model="form.code_quantity"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="pl-3 pt-2">
            <b-form-group
              class="secondary-label"
              :id="'is-unlimited-group' + '-' + fromWhatModal"
              v-if="false"
            >
              <b-form-checkbox
                :id="'is-unlimited-input' + '-' + fromWhatModal"
                v-model="form.is_unlimited"
                name="checkbox-1"
              >
                Unlimited
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col sm="12" md="4">
        <h6 class="main-label">Value</h6>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4">
            <b-form-group
              id="voucherValueType"
              label="Type"
              label-for="valueType"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('value_type')"
              :state="isValid('value_type')"
            >
              <b-form-select
                :disabled="form.is_free_delivery"
                :options="currencyOptions"
                v-model="form.value_type"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              id="voucherValue"
              label="Amount"
              label-for="value"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('value')"
              :state="isValid('value')"
            >
              <b-form-input
                type="number"
                v-model="form.value"
                min="1"
                :disabled="form.is_free_delivery"
                :max="form.value_type == '%' ? 99 : 10000000000"
                oninput="this.value = Math.abs(this.value)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2 d-none">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters class="d-none">
      <b-col sm="12" md="4">
        <h6 class="main-label">Free Delivery</h6>
      </b-col>
      <b-col>
        <b-row>
          <switches
            v-model="form.is_free_delivery"
            theme="custom"
            color="primary"
            text-enabled="On"
            text-disabled="Off"
            type-bold="true"
            style="top: -4px; left: 12px"
          ></switches>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col sm="12" md="4">
        <h6 class="main-label">Delivery Discount</h6>
      </b-col>
      <b-col>
        <b-row>
          <switches
            v-model="form.is_delivery_discount_enable"
            theme="custom"
            color="primary"
            text-enabled="On"
            text-disabled="Off"
            type-bold="true"
            style="top: -4px; left: 12px"
            :disabled="form.is_free_delivery"
          ></switches>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-input-group prepend="%">
              <b-form-input
                v-model="form.delivery_discount_value"
                :disabled="
                  form.is_free_delivery || !form.is_delivery_discount_enable
                "
                @keypress.native="isNumber($event)"
                :formatter="percentageFormat"
                :state="deliveryDiscountState"
              ></b-form-input>
              <b-form-invalid-feedback>
                Free delivery should be turned off.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col sm="12" md="4">
        <h6 class="main-label">
          <!-- <template v-if="form.voucher_type != 'unique'"> -->
          <template>
            Duration of Campaign<i
              id="duration-of-campaign-label-help"
              class="help d-none"
            ></i>
            <b-popover
              target="duration-of-campaign-label-help"
              triggers="hover"
              content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            >
            </b-popover>
          </template>
          <!-- <template v-else>
            Period
          </template> -->
        </h6>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="voucherStartDate"
              label="Start Date"
              for="startDate"
              class="secondary-label mb-0"
              :invalid-feedback="errorMessage('start_date')"
              :state="isValid('start_date')"
            >
              <div class="custom-datepicker mb-3 muli-sb">
                <SingleDatepicker
                  :bootstrap-styling="true"
                  :value="form.start_date"
                  ref="programaticOpenStart"
                  v-model="form.start_date"
                  wrapper-class="custom-datepicker"
                  style="color: #2a2a2a !important"
                  :disabled="form.is_date_applicable == false"
                >
                  <div slot="afterDateInput" class="input-group-append pr-0">
                    <span class="input-group-text">
                      <img
                        @click="openPicker('start')"
                        src="@/assets/images/icons/calendar.svg"
                        alt="Calendar Icon"
                        class="form-icon action-button"
                      />
                    </span>
                  </div>
                </SingleDatepicker>
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="voucherEndDate"
              label="End Date"
              for="endDate"
              class="secondary-label mb-0"
              :invalid-feedback="errorMessage('end_date')"
              :state="isValid('end_date')"
            >
              <div class="custom-datepicker mb-3 muli-sb">
                <SingleDatepicker
                  :bootstrap-styling="true"
                  :value="form.end_date"
                  ref="programaticOpenEnd"
                  v-model="form.end_date"
                  wrapper-class="custom-datepicker"
                  style="color: #2a2a2a !important"
                  :disabled="form.is_date_applicable == false"
                >
                  <div slot="afterDateInput" class="input-group-append pr-0">
                    <span class="input-group-text">
                      <img
                        @click="openPicker('end')"
                        src="@/assets/images/icons/calendar.svg"
                        alt="Calendar Icon"
                        class="form-icon action-button"
                      />
                    </span>
                  </div>
                </SingleDatepicker>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row v-if="form.voucher_type != 'unique'"> -->
        <b-row>
          <b-col>
            <b-form-group class="secondary-label">
              <b-form-checkbox
                :id="'is-date-applicable' + '-' + fromWhatModal"
                v-model="form.is_date_applicable"
                name="is-date-applicable"
              >
                Applicable on a Certain Day Only
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row v-if="form.voucher_type != 'unique' && false"> -->
        <b-row>
          <b-col md="6">
            <div id="custom-timepicker" style="width: 164px">
              <b-form-group
                :invalid-feedback="errorMessage('start_time')"
                :state="isValid('start_time')"
              >
                <label class="secondary-label align-top">Start Time</label>
                <b-form-input
                  :disabled="
                    form.is_time_applicable == false ||
                    form.is_date_applicable == false
                  "
                  type="time"
                  v-model="form.start_time"
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
          <b-col md="6">
            <div id="custom-timepicker" style="width: 164px">
              <b-form-group
                :invalid-feedback="errorMessage('end_time')"
                :state="isValid('end_time')"
              >
                <label class="secondary-label align-top">End Time</label>
                <b-form-input
                  :disabled="
                    form.is_time_applicable == false ||
                    form.is_date_applicable == false
                  "
                  type="time"
                  v-model="form.end_time"
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <!-- <b-row v-if="form.voucher_type != 'unique' && false"> -->
        <b-row>
          <b-col>
            <b-form-group class="secondary-label">
              <b-form-checkbox
                :id="'is-time-applicable' + '-' + fromWhatModal"
                v-model="form.is_time_applicable"
                name="is-time-applicable"
              >
                Applicable on a Certain Time Only
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <!-- <b-row no-gutters v-if="form.voucher_type == 'generic'"> -->
    <b-row no-gutters>
      <b-col sm="12" md="4">
        <h6 class="main-label">
          Duration of Redemption<i
            id="duration-of-campaign-label-help"
            class="help d-none"
          ></i>
        </h6>
        <b-popover
          target="duration-of-campaign-label-help"
          triggers="hover"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        >
        </b-popover>
      </b-col>
      <b-col>
        <b-row no-gutters>
          <b-col>
            <b-form-group
              label="Days"
              class="secondary-label"
              :invalid-feedback="errorMessage('duration_redemption')"
              :state="isValid('duration_redemption')"
            >
              <b-form-checkbox-group
                id="checkbox-group-2"
                v-model="form.duration_redemption"
                name="flavour-2"
                stacked
              >
                <b-form-checkbox value="Monday"> Monday </b-form-checkbox>
                <b-form-checkbox value="Tuesday"> Tuesday </b-form-checkbox>
                <b-form-checkbox value="Wednesday"> Wednesday </b-form-checkbox>
                <b-form-checkbox value="Thursday"> Thursday </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="secondary-label" style="margin-top: 26px">
              <b-form-checkbox-group
                id="checkbox-group-2"
                v-model="form.duration_redemption"
                name="flavour-2"
                stacked
              >
                <b-form-checkbox value="Friday"> Friday </b-form-checkbox>
                <b-form-checkbox value="Saturday"> Saturday </b-form-checkbox>
                <b-form-checkbox value="Sunday"> Sunday </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row no-gutters v-if="form.voucher_type != 'unique'">
          <b-col>
            <b-form-group
              id="voucherName"
              label-for="name"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('max_user_redemption')"
              :state="isValid('max_user_redemption')"
            >
              <label for="minimumTopUp">
                Max User Redemption
                <i id="max-user-redemption-help" class="help d-none"></i>
                <b-popover
                  target="max-user-redemption-help"
                  triggers="hover"
                  content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                ></b-popover>
              </label>
              <b-form-select
                v-if="fromWhatModal == 'new'"
                :options="maxUserRedemptionOptions"
                v-model="form.max_user_redemption"
              ></b-form-select>
              <b-form-select
                v-else-if="fromWhatModal == 'edit'"
                disabled
                :options="maxUserRedemptionOptions"
                v-model="form.max_user_redemption"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2" v-if="form.voucher_type == 'unique'">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters v-if="form.voucher_type == 'unique'">
      <b-col sm="12" md="4">
        <h6 class="main-label">Voucher Codes</h6>
        <span class="csv-helper">
          CSV
          <!-- <a
            href="https://s3-ap-southeast-1.amazonaws.com/drr.cms.rush.ph/import/estore_voucher_import_template.csv"
          >(Template)</a> -->
          <downloadexcel
            class="template-button"
            :fields="json_fields"
            :data="json_data"
            type="csv"
            name="estore_voucher_import_template.csv"
          >
            (Template)
          </downloadexcel>
        </span>
      </b-col>
      <b-col>
        <b-form-group
          class="secondary-label mb-3"
          :invalid-feedback="errorMessage('voucher_codes')"
          :state="isValid('voucher_codes')"
        >
          <b-form-file
            class="select-file"
            ref="file-input"
            v-model="form.voucher_codes"
            placeholder="Select .csv"
            accept=".csv"
          ></b-form-file>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col sm="12" md="4">
        <h6 class="main-label">Visibility</h6>
      </b-col>
      <b-col>
        <b-form-group
          id="voucherVisibility"
          label="Publish in App"
          for="visibility"
          class="secondary-label mb-3"
        >
          <switches
            v-model="form.visibility"
            theme="custom"
            color="primary"
            text-enabled="On"
            text-disabled="Off"
            type-bold="true"
            style="top: 0"
          ></switches>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col sm="12" md="4">
        <h6 class="main-label">Applicable to specific channel</h6>
      </b-col>
      <b-col>
        <b-row no-gutters>
          <b-col>
            <b-form-group label="Website" class="secondary-label mb-3">
              <switches
                v-model="form.is_website_applicable"
                theme="custom"
                color="primary"
                text-enabled="On"
                text-disabled="Off"
                type-bold="true"
                style="top: 0"
              ></switches>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <b-form-group label="Customer App" class="secondary-label mb-3">
              <switches
                v-model="form.is_customer_app_applicable"
                theme="custom"
                color="primary"
                text-enabled="On"
                text-disabled="Off"
                type-bold="true"
                style="top: 0"
              ></switches>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <b-form-group label="GCash GLife" class="secondary-label mb-3">
              <switches
                v-model="form.is_gcash_mp_applicable"
                theme="custom"
                color="primary"
                text-enabled="On"
                text-disabled="Off"
                type-bold="true"
                style="top: 0"
              ></switches>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-2">
      <b-col sm="12" md="4">
        <h6 class="main-label">Minimum Spend</h6>
      </b-col>
      <b-col>
        <b-row no-gutters>
          <b-col>
            <b-form-group
              label="Amount"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('minimum_spend')"
              :state="isValid('minimum_spend')"
            >
              <b-form-input
                type="number"
                min="1"
                max="9999999999"
                pattern="/^-?\d+\.?\d*$/"
                onKeyPress="if(this.value.length==10) return false;"
                v-model="form.minimum_spend"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <hr class="form-divider" />
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-2">
      <b-col sm="12" md="4">
        <h6 class="main-label">Maximum Discount</h6>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4">
            <b-form-group
              id="voucherValueType"
              label="Type"
              label-for="valueType"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('maximum_discount_value_type')"
              :state="isValid('maximum_discount_value_type')"
            >
              <b-form-select
                :disabled="form.is_free_delivery"
                :options="currencyOptions"
                v-model="form.maximum_discount_value_type"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              id="voucherValue"
              label="Amount"
              label-for="value"
              class="secondary-label mb-3"
              :invalid-feedback="errorMessage('maximum_discount_value')"
              :state="isValid('maximum_discount_value')"
            >
              <b-form-input
                type="number"
                :disabled="form.is_free_delivery"
                v-model="form.maximum_discount_value"
                min="1"
                :max="
                  form.maximum_discount_value_type == '%' ? 99 : 10000000000
                "
                oninput="this.value = Math.abs(this.value)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SingleDatepicker from "vuejs-datepicker";
import Switches from "vue-switches";
import VueTimepicker from "vue2-timepicker";
import downloadexcel from "vue-json-excel";

export default {
    name: "StoreVoucherForm",
    props: ["form", "fromWhatModal", "status"],
    components: {
        SingleDatepicker,
        Switches,
        VueTimepicker,
        downloadexcel
    },
    data() {
        return {
            json_fields: {
                "Voucher Number": "voucher_number"
            },
            json_data: [
                {
                    voucher_number: "10000000021"
                },
                {
                    voucher_number: "10000000122"
                }
            ],
            currencyOptions: [
                { value: "php", text: "Php" },
                { value: "%", text: "%" }
            ],
            maxUserRedemptionOptions: [
                { value: 1, text: "1" },
                { value: 2, text: "2" },
                { value: 3, text: "3" },
                { value: 4, text: "4" },
                { value: 5, text: "5" },
                { value: 6, text: "6" },
                { value: 7, text: "7" },
                { value: 8, text: "8" },
                { value: 9, text: "9" },
                { value: 10, text: "10" }
            ],
            dropdownStatus: "closed",
            testForm: {
                free: false
            }
        };
    },
    computed: {
        ...mapState("estoreVouchers", ["errors"]),
        deliveryDiscountState() {
            if (
                this.form.is_free_delivery &&
                this.form.is_delivery_discount_enable
            ) {
                return false;
            }

            return null;
        }
    },
    methods: {
        openPicker: function(calendar) {
            if (calendar == "start")
                this.$refs.programaticOpenStart.showCalendar();
            else if (calendar == "end")
                this.$refs.programaticOpenEnd.showCalendar();
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        isLetterOrNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[A-Za-z0-9]+$/.test(char)) return true;
            else e.preventDefault();
        },
        isNumber(e) {
            if (/[^0-9]/.test(String.fromCharCode(e.keyCode)))
                e.preventDefault();
        },
        percentageFormat(value) {
            if (!value) return "";

            let parsedValue = parseInt(value);

            if (parsedValue > 100) return parsedValue.toString().slice(0, 2);

            return parsedValue;
        }
    },
    watch: {
        status: function(status) {
            if (this.$refs["file-input"] != undefined && status == false) {
                this.$refs["file-input"].reset();
            }
        },
        "form.is_time_applicable": function(is_time_applicable) {
            let currentTime = new Date().toLocaleTimeString([], {
                hour12: false,
                hour: "2-digit",
                minute: "2-digit"
            });

            if (
                is_time_applicable &&
                this.form.start_time == "" &&
                this.form.end_time == ""
            ) {
                this.form.start_time = currentTime;
                this.form.end_time = currentTime;
            }
            //  else {
            //     this.form.start_time = "";
            //     this.form.end_time = "";
            // }

            if (!is_time_applicable) {
                this.form.start_time = "";
                this.form.end_time = "";
            }
        },
        "form.is_date_applicable": function(is_date_applicable) {
            if (is_date_applicable) {
                this.form.start_date = new Date();
                this.form.end_date = new Date();
            } else {
                this.form.is_time_applicable = false;
                this.form.start_date = null;
                this.form.end_date = null;
                this.form.start_time = null;
                this.form.end_time = null;
            }
        },
        "form.is_unlimited": function(is_unlimited) {
            if (is_unlimited) {
                this.form.code_quantity = null;
            } else {
                if (this.form.uuid == undefined) {
                    this.form.code_quantity = 1;
                } else if (
                    this.form.uuid != undefined &&
                    this.form.code_quantity == null
                ) {
                    this.form.code_quantity = 1;
                }
            }
        }
    }
};
</script>
<style lang="scss">
#voucher-type-container {
    .custom-control-label::after {
        top: 3.9px !important;
    }
}
#unlimited-container {
    .custom-checkbox .custom-control-label::before {
        top: 3px !important;
    }
    .custom-control-label::after {
        top: 2.9px !important;
    }
}
.csv-helper {
    font-family: MainFontBold, sans-serif;
    font-size: 15px;
    color: #979797;
    a {
        color: #007bff;
        cursor: pointer;
    }
}
.input-group-text {
    background: #ffffff;
}
</style>
